/**
 * Headroom integration for the site header.
 */
(function () {
	'use strict';

	function init() {
		var header = document.querySelector('#page-top');
		if (!header || typeof window.Headroom !== 'function') {
			return;
		}

		var headroom = null;

		function updateHeaderHeight() {
			var height = header.offsetHeight || 0;
			document.documentElement.style.setProperty('--gardp-header-height', height + 'px');
			if (headroom) {
				headroom.offset = height;
			}
		}

		updateHeaderHeight();

		if (window.ResizeObserver) {
			var ro = new ResizeObserver(function () {
				updateHeaderHeight();
			});
			ro.observe(header);
		} else {
			window.addEventListener('resize', updateHeaderHeight);
		}

		headroom = new window.Headroom(header, {
			offset: header.offsetHeight || 0,
			tolerance: { up: 6, down: 10 },
		});
		headroom.init();

		// Prevent the header from hiding while the mega menu or mobile nav overlay is open.
		if (window.MutationObserver) {
			function syncHeadroomFreeze() {
				var shouldFreeze =
					header.classList.contains('is-mega-menu-open') ||
					document.documentElement.classList.contains('has-modal-open');

				if (shouldFreeze) {
					headroom.freeze();
				} else {
					headroom.unfreeze();
				}
			}

			var headerObserver = new MutationObserver(syncHeadroomFreeze);
			headerObserver.observe(header, { attributes: true, attributeFilter: ['class'] });

			var documentObserver = new MutationObserver(syncHeadroomFreeze);
			documentObserver.observe(document.documentElement, {
				attributes: true,
				attributeFilter: ['class'],
			});
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init, { once: true });
	} else {
		init();
	}
})();

